const MAX_SAFE_CURRENCY = Number.MAX_SAFE_INTEGER;

export type Currency = "USD" | "EUR" | "GBP" | "CAD";

const CURRENCY_LOCALES: Record<Currency, string> = {
  USD: "en-US",
  EUR: "de-DE",
  GBP: "en-GB",
  CAD: "en-CA",
};

/**
 * Format a number as currency.
 * Handles Infinity and overflow gracefully.
 * @param value - Amount to format
 * @param currency - Currency code (default USD)
 */
export function formatCurrency(
  value: number,
  currency: Currency = "USD"
): string {
  if (!Number.isFinite(value) || value > MAX_SAFE_CURRENCY) {
    return "Too large to display";
  }
  if (value < -MAX_SAFE_CURRENCY) {
    return "Too small to display";
  }
  return new Intl.NumberFormat(CURRENCY_LOCALES[currency], {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

/**
 * Format a number as a percentage.
 */
export function formatPercent(value: number, decimals = 2): string {
  return new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value / 100);
}
